import moment from 'moment/moment';
import React, {useState , useEffect} from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Button, Input, Label, Col, Container, Row, ListGroup, ListGroupItem, Card, CardBody, CardHeader } from 'reactstrap';
import { Bot_Thread, Bot_Thread_Create, Bot_Thread_Delete, Bot_Thread_Delete_Bulk } from '../../slices/thunks';
import BotThreadList from './BotThreadList';
import ConfirmModal from '../../Components/Common/CustomModal/ConfirmModal';
import Loader from '../../Components/Common/Loader';
import { close_confirm_modal, open_confirm_modal } from '../../slices/Confirm_Modal/reducer';
import { waitForDecision } from '../../utility/wait_for_confirmation';
import { get_Threads } from '../../helpers/fakebackend_helper';




const BotThreads = () => {

  const { threadList , loading } = useSelector((state)=>state.Threads)
  const {Assets_ID , User_Role, Bot_ID } = useSelector((state)=>state.BotDetails.Bot_Details)
  const dispatch = useDispatch()
  const [selectAll, setselectAll] = useState(false)
  const [delete_thread_list, setdelete_thread_list] = useState([])


  const onClickAdd_select_thread_for_deletion = (thread_id) => {
          
         const already_there = delete_thread_list.find(thread => thread.thread_id === thread_id)


         if(!already_there){

           setdelete_thread_list([...delete_thread_list , {  assets_id:Assets_ID , thread_id:thread_id}])
         }
  }


  const onClick_remove_from_selected_thread_list = (thread_id) =>{
        let temp_delete_thread_list = delete_thread_list.filter(thread => thread.thread_id !== thread_id)

        setdelete_thread_list(temp_delete_thread_list)
         


  }


  const remove_all_from_selected = ()=>{
       setdelete_thread_list([])
  }


  const select_all_into_selected_thread = ()=>{
    const temp = threadList.map((ele)=>{
      return { assets_id:Assets_ID , thread_id:ele.thread_id }
    })


 
    


    setdelete_thread_list(temp)
  }



  const onClick_Delete_Bulk = () =>{



    // console.log(delete_thread_list);
    

    if(!delete_thread_list.length > 0){
      return
    }
                                    


        dispatch(open_confirm_modal(" Are you sure you want to delete these thread")) 

   waitForDecision().then((decision)=>{

    
    if(decision){
          
        // console.log(delete_thread_list.map((ele)=>ele.thread_id).join(','));
        
        dispatch(Bot_Thread_Delete({id:delete_thread_list.map((ele)=>ele.thread_id).join(','), Bot_ID: Bot_ID}))
        // dispatch(Bot_Thread_Delete_Bulk({ threads:delete_thread_list }))

      
          
       }


       dispatch(close_confirm_modal())

   });
        
  }


  useEffect(() => {


    

    if(selectAll){
      select_all_into_selected_thread()
    }else{
      remove_all_from_selected()
    }
   
  }, [selectAll])
  

  useEffect(()=>{
    if( threadList && threadList.length == 0 && User_Role!=='Viewer' && Bot_ID){
  
      dispatch(Bot_Thread_Create(Bot_ID))

    }
  },[threadList])



  const [isActive, setIsActive] = useState(false);
  const [isUp, setIsUp] = useState(false);
  const handleToggle = () => {
    setIsActive((prev) => !prev); // Toggle the state
    setIsUp((prev) => !prev);
  };
  return (
  
          <div className='botthreads'>
            <ConfirmModal/>
              <div className='mob-view'>                
                <button  className="text-body-secondary" onClick={handleToggle} style={{border:'none', backgroundColor:'transparent'}}> Bot Threads 
                  <i style={{fontSize:'14px'}} className={isUp ? "ri-arrow-drop-down-line" : "ri-arrow-drop-up-line"}></i></button>  
                <div className='sw-mob'>
                {  <Button onClick={()=>{
                          dispatch(Bot_Thread_Create(Bot_ID))
                        }} > CREATE NEW THREAD </Button>}

                </div>              
              </div>
              <div className={isActive ? "ns-mob active" : "ns-mob"}>
                <Row>
                  <Col>
                    <div className='sada_cs'>
                      
                      { User_Role !== 'Viewer' &&  <div>
                        <span>
                          <div className="form-check form-check-outline form-check-primary mb-3">
                              <Input checked={selectAll} onChange={(e)=>{
                                  setselectAll(!selectAll)
                              }}  className="form-check-input" type="checkbox" id="formCheck13" />
                              <Label className="form-check-label" htmlFor="formCheck13">
                                Select all
                              </Label>
                          </div>
                        </span>
                        <span onClick={onClick_Delete_Bulk} style={{ cursor:'pointer' }} className='red'>
                          <i className='ri-delete-bin-line'></i> Delete
                        </span>
                      </div>}
                      <div className='ns-mob'>
                        { <Button onClick={()=>{
                          dispatch(Bot_Thread_Create(Bot_ID))
                        }} > NEW THREAD </Button>}
                        {/* <span>
                          <div className="input-group"><Input placeholder="Search Bot name" aria-label="Recipient's username with two button addons" type="text" class="form-control h-40 form-control" />
                          <button className="btn btn-primary padd_10" type="button"><i className="bx bx-search fs-20"></i></button></div>
                        </span> */}
                      </div>
                    </div>
                  </Col>
                </Row>   
                <Row>
                   <Col>
                  {loading? <Loader/> :  <ListGroup className="bot-thread-height">
                   {
      threadList?.map((thread,i)=>{
                    return <BotThreadList onClickAdd_select_thread_for_deletion={onClickAdd_select_thread_for_deletion}  onClick_remove_from_selected_thread_list={onClick_remove_from_selected_thread_list}  key={i} thread={thread} selectAll={selectAll} setselectAll={setselectAll} />
      })}
                   </ListGroup>}
                   </Col>
                </Row>             
            </div>
              
          </div>
  )
}

export default BotThreads
